import { z } from 'zod';
import { defineEndpoint } from '../define';

export const deletePoll = defineEndpoint({
  method: 'DELETE',
  path: '/v1/polls/:pollId',
  params: z.object({ pollId: z.string().uuid() }),
  query: z.object({}),
  body: z.undefined(),
  response: z.object({}),
  successStatus: 204,
});
